/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 * Page Reports Constructor component
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import styled from 'styled-components';

import { TABLE_FOOTER_BOTTOM_STYLE } from '@components/Table/constants';
import { colors } from '@theme/index';

export const ConstructorFooterStyled = styled.div`
    position: fixed;
    z-index: 3;
    left: 0;
    bottom: ${TABLE_FOOTER_BOTTOM_STYLE}px;
    width: 100%;
    height: 64px;
    background: ${colors.tableFooterBgColor};
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);
`;

export const ConstructorFooterControlsStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 1280px;
    padding: 0 40px;
`;

export const ConstructorFooterControlsLinkStyled = styled.div`
    flex: 1;
`;

export const ConstructorFooterControlsItemStyled = styled.div`
    margin-left: 32px;
`;
